import React, { useEffect, useRef, useState } from 'react';
import { Box, Image, Link } from '@chakra-ui/react';

const HEADER_HEIGHT = 70;

const SideBarStickyContent = ({
  stickyHeight,
  children,
}: {
  stickyHeight: number;
  children: React.ReactNode;
}) => {
  const [isSticky, setIsSticky] = useState(false);
  const [elementWidth, setElementWidth] = useState('auto');
  const elementRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentElement = elementRef.current;
      if (currentElement && window.innerWidth > 767) {
        setIsSticky(window.scrollY >= stickyHeight);
      } else {
        setIsSticky(false);
      }
    };

    const handleResize = () => {
      const currentElement = elementRef.current;
      if (currentElement) {
        if (window.innerWidth > 767) {
          setElementWidth(`${currentElement.offsetWidth}px`);
        } else {
          setElementWidth('auto');
        }
        setIsSticky(
          window.innerWidth > 767 && window.scrollY >= currentElement.offsetTop,
        );
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);

    // 初期状態の設定
    handleResize();

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [stickyHeight]);

  return (
    <Box
      ref={elementRef}
      position={isSticky ? 'fixed' : 'relative'}
      top={isSticky ? HEADER_HEIGHT : 'auto'}
      width={isSticky && window.innerWidth > 767 ? elementWidth : 'auto'}
    >
      {children}
    </Box>
  );
};

export default SideBarStickyContent;
